import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogData } from './_models/confirm-dialog-data.model';
import { DialogResult } from '../../../models/dialog/dialog-result.model';
import { DialogButton } from '../../../enums/dialog-button.enum';

/**
 * A dialog component to prompt the user for a YES/NO answer
 */
@Component({
  selector: 'lm-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  /** The title of the confirm dialog */
  public title: string;

  /** The message to display in the confirm dialog */
  public message: string;

  /**
   * @param dialogRef - A reference to the dialog component
   * @param data - The data passed to the dialog. An instance of ConfirmDialogData containing the dialog's title and message
   */
  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: ConfirmDialogData
  ) {
    dialogRef.disableClose = true;
    this.title = data.title;
    this.message = data.message;
  }

  /**
   * Method called when the dialog is cancelled
   */
  public onClose() {
    const dialogResult = new DialogResult(DialogButton.Cancel);
    this.dialogRef.close(dialogResult);
  }

  /**
   * Method callsed when the OK button is pressed
   */
  public onConfirm() {
    const dialogResult = new DialogResult(DialogButton.OK);
    this.dialogRef.close(dialogResult);
  }
}
